/* eslint-disable max-len */
import { formatDateZone } from '@utils/date-helpers'
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('spaSoft', ['genderOptions']),
    ...mapGetters('spaSoft', ['guestsSelectedData', 'getTreatmentPriceFormatted']),
  },
  methods: {
    getStartEndLabel(itinerary) {
      const { start, end } = itinerary
      return `${formatDateZone(start, null, 'h:mm a')} - ${formatDateZone(end, null, 'h:mm a')}`
    },
    timeSlotDetails({ guestNumber, itinerary }) {
      const guestData = this.guestsSelectedData[guestNumber]
      return guestData.selectedTreatments.find((treatment) => treatment?.selectedTimeSlot?.spaSoftId === itinerary?.treatmentId) || null
    },
    getTreatmentName({ guestNumber, itinerary }) {
      return this.timeSlotDetails({ guestNumber, itinerary })?.sitecoreTreatmentDetails?.title || ''
    },
    getTreatmentDuration({ guestNumber, itinerary }) {
      return this.timeSlotDetails({ guestNumber, itinerary })?.selectedTimeSlot?.duration || ''
    },
    getGenderPreference({ guestNumber, itinerary }) {
      const preferredGender = this.timeSlotDetails({ guestNumber, itinerary })?.selectedTimeSlot?.preferredGender
      const selectedGender = this.genderOptions.find((option) => option.value === preferredGender)
      return selectedGender?.label || ''
    },
    getPriceWithIsoCode({ guestNumber, itinerary }) {
      const selectedTreatment = this.timeSlotDetails({ guestNumber, itinerary })?.selectedTimeSlot
      return this.getTreatmentPriceFormatted({ treatment: selectedTreatment, checkTaxes: true })
    }
  },
}
